import React from 'react';
import PropTypes from 'prop-types';
import { FastField } from 'formik';
import Box from '@material-ui/core/Box';
import _e from 'common/localeUtil';
import FieldWrapper from '../FieldWrapper';
import FormStatusComponent from '../FormStatusComponent';
import GMButton from '../../button/GMButton';

const FormFieldOneInput = ({
	errorMessage,
	description,
	control = 'input',
	fieldName,
	placeholder,
	help,
	defaultFieldValue,
	setFieldValue,
	forceRefresh,
}) => {
	const setContent = (content) => {
		setFieldValue && setFieldValue(fieldName, content);
		forceRefresh && forceRefresh();
	};
	const clearContent = () => {
		setContent('');
	};
	const resetDefaultDisclaimer = () => {
		setContent(defaultFieldValue);
	};

	let field;
	if (control === 'editor') {
		field = (
			<>
				<FastField
					name={fieldName}
					control="editor"
					component={FieldWrapper}
					numRows={20}
					toolbarConfig={{
						h1: false,
						h2: false,
						h3: false,
						h4: false,
						history: false,
						link: false,
						image: false,
						superscript: true,
					}}
					placeholder={placeholder}
					help={help}
				/>
				<div className={`text-right mt-1`}>
					<GMButton variant="text" title={_e('clear_content')} onClick={clearContent} />
					{defaultFieldValue && (
						<GMButton
							variant="text"
							title={_e('reset_disclaimer')}
							onClick={resetDefaultDisclaimer}
						/>
					)}
				</div>
			</>
		);
	} else if (control === 'input') {
		field = (
			<FastField
				name={fieldName}
				control="input"
				component={FieldWrapper}
				placeholder={placeholder}
				help={help}
			/>
		);
	}

	return (
		<>
			{description && <Box mb={2}>{description}</Box>}
			<Box mb={2}>{field}</Box>
			{errorMessage && (
				<Box p={1}>
					<FormStatusComponent error={errorMessage} />
				</Box>
			)}
		</>
	);
};

FormFieldOneInput.propTypes = {
	errorMessage: PropTypes.string,
	description: PropTypes.string,
	control: PropTypes.string,
	fieldName: PropTypes.string,
	placeholder: PropTypes.string,
	help: PropTypes.string,
	defaultFieldValue: PropTypes.string,
	setFieldValue: PropTypes.func,
	forceRefresh: PropTypes.bool,
};

export default FormFieldOneInput;
